<template>
  <div class="page">
    <!-- <div class="navigation-bar">
     <list></list>
    </div> -->
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>

    <div class="box-card">
      <teacherCard
        v-for="(item, index) in mydata.threeCard"
        :info="item"
        :key="index"
      ></teacherCard>
    </div>
    <div class="box-title">
      <textBar :data="mydata.text">
        <template #abc>
          <!-- <div class="title-button">
            <el-button round>了解更多</el-button>
          </div> -->
          <p @click="enterpriseFn">
            查看更多
            <el-icon><ArrowRight /></el-icon>
          </p>
        </template>
      </textBar>
    </div>
    <div class="box-news" v-if="mydata.articleListArr.length !== 0">
      <div class="news-left" @click="newsLeftClick">
        <img v-complete:src="mydata.articleListArr[0]?.image" alt="" />
        <p>{{ mydata.articleListArr[0]?.title }}</p>
        <div class="left-time">
          <p>
            {{
              dayjs(mydata.articleListArr[0]?.release_time * 1000).format(
                "YYYY/MM/DD"
              )
            }}
          </p>
          <!-- <el-icon><Right /></el-icon> -->
          <p style="display: flex; align-items: center">
            <span>———</span>
            <el-icon><ArrowRight /></el-icon>
          </p>
        </div>
      </div>
      <!-- ------------ -->
      <div class="news-right">
        <newsRight
          :path="mydata.path"
          v-for="(item, index) in mydata.articleListArr.slice(1)"
          :key="index"
          :info="item"
        ></newsRight>
      </div>
    </div>
    <div
      v-else
      style="
        height: 379px;
        text-align: center;
        line-height: 379px;
        color: #999999;
      "
    >
      暂无数据
    </div>

    <!--  -->
    <!-- 右侧悬浮组件 -->
    <!-- <floatingComponents></floatingComponents> -->
    <!--  -->
  </div>
</template>

<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";

import teacherCard from "@/components/teacherCard/index.vue";
import newsRight from "@/components/newsRight/index.vue";
// import bottomBar from "@/components/bottomBar/index.vue";
import textBar from "@/components/textBar/index.vue";

// import floatingComponents from "@/components/floatingComponents/index.vue";

import { Right } from "@element-plus/icons-vue";
import { reactive } from "vue";
import dayjs from "dayjs";

//引入articleList接口
import { articleList } from "@/api/home/index.js";

// import { ElMessage } from "element-plus";
// import { useRouter } from "vue-router";
import { useRouter, useRoute } from "vue-router";

import { getMenuChildren } from "@/utils/slide.js";
// import { useStore } from "vuex";

// 引入接口
import { getUrlId } from "@/utils/slide.js";

import { homeComprehensive } from "@/api/home/index.js";

// const store = useStore();

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  teacherHandChildren: getMenuChildren("/layout/list/teacherHand"),
  threeCard: [],
  myNews: 3,

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  path: "/layout/list/enterpriseDetails",

  articleListArr: [], //文章列表

  form: {
    // column_id: getUrlId(route.path), // 栏目id值
    // column_id: getUrlId("/layout/list/walkIntroTianLi"), // 栏目id值
    column_id: 39, // 栏目id值
    // search: "", // 搜索查询
    // stage: "", //学段
    // theme: "", //主题
    // subject: "", //学科
  },
});

// function init() {
//   let id1 = getUrlId("/layout/list/teacherHand");
//   let id2 = getUrlId("/layout/list/studentWorld");
//   let id3 = getUrlId("/layout/list/parentSchool");
//   let menuList = JSON.parse(localStorage.getItem("menuList"));
//   let obj1 = menuList.find((item) => item.id === Number(id1));
//   let obj2 = menuList.find((item) => item.id === Number(id2));
//   let obj3 = menuList.find((item) => item.id === Number(id3));
//   mydata.threeCard = [obj1, obj2, obj3];
// }
// init();

function getHomeComprehensive() {
  homeComprehensive().then((res) => {
    mydata.threeCard = res.data.map((item) => {
      item.descr = item.descr.replace(/\n/gi, "<br>");
      return item;
    });
    // console.log(  mydata.threeCard);
  });
}
getHomeComprehensive();

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    psize:3
  }).then((res) => {
    // console.log("文章列表123321123", res.data);
    mydata.articleListArr = res.data.list;
  });
}

// 调用函数
articleListFn();

//点击更多跳转至走进天利的企业动态
function enterpriseFn() {
  router.push({
    path: "/layout/list/walkIntroTianLi",
    query: { text: "企业动态" },
  });
}

function newsLeftClick() {
  router.push({
    path: mydata.path,
    query: { id: mydata.articleListArr[0].id },
  });
}
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  height: calc(100% - 95px);
  padding-bottom: 24px;
  // border: 1px solid red;
  // background-color: rgb(255, 0, 242);
  //  height: calc(100vh - 48px);
  // min-height: calc(900px - 48px);
  // overflow: hidden; // 解决margi-top样式穿透问题

  // .navigation-bar {
  // width: 100%;
  // height: 96px;
  // background-color: #ffffff;
  // display:flex;
  // justify-content: center;
  // align-items: center;
  // >img{
  //   margin-right:86px;
  // }
  // >p{
  //   font-size:16px;
  //   color:#009DE0;
  //   margin-right:26px;
  // }
  // }
  // .box-img {
  //   width: 100%;
  //   height: 716px;
  //   // border:1px solid rgb(255, 0, 0);
  //   // >img{

  //   // }
  // }

  /* 针对webkit内核浏览器 */
  .box-card::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
    height: 0px;
  }
  .box-card {
    // width: 1202px !important;
    // height: 397px;
    // border: 1px solid rgb(0, 115, 255);
    margin: 0 auto;
    margin-top: 16px;
    padding-left: 16px;
    padding-right: 16px;

    display: flex;

    overflow-x: auto;
    overflow-y: hidden;

    // border: 1px solid red;

    /* 自定义整个滚动条 */
    // ::-webkit-scrollbar {
    //   height: 0px !important; /* 设置滚动条的宽度 */
    // }

    .techer-card {
      margin-right: 16px;
    }
    // .techer-card:last-of-type {
    //   margin-right: 16px;
    // }
    :deep(.techer-card:last-of-type) {
      margin-right: 0 !important;
    }
  }

  .box-title {
    // margin-top: 73px;
    // :deep(.el-button.is-round){
    //   // margin-top:13px;
    // }
    .text-bar {
      > p {
        color: #969696;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      > p:hover {
        color: #009de0;
      }
    }
  }

  .box-news {
    width: 343px !important;
    // height: 379px;
    // border: 1px solid rgb(119, 255, 0);
    overflow: hidden;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 18px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // margin-bottom:40px;
    .news-left {
      cursor: pointer;
      // width: 500px;
      height: 100%;
      padding-bottom: 16px;
      overflow: hidden;
      border-bottom: 1px solid #cccccc;
      > img {
        width: 343px;
        // height: 281px;
        display: block;
        border-radius: 8px;
      }
      > p {
        // height: 24px;
        font-size: 16px;
        font-weight: 700;
        color: #333333;
        margin-top: 16px;

        // white-space: nowrap; //不折行
        // text-overflow: ellipsis; //文本溢出 用省略号显示
        // overflow: hidden;
        line-height: 24px;
        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;
      }

      .left-time {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;
        > p {
          font-size: 12px;
          font-weight: 400px;
          color: #333333;
          span {
            margin-right: -4px;
            // margin-top: -3px;
          }
        }
      }
    }
    .news-left:hover {
      p {
        color: #009de0;
      }
    }
    .news-right {
      // height: 100%;
      margin-top: 18px;
      // border:1px solid #cc0505;
      overflow: hidden;
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      :deep(.right-item) {
        margin-bottom: 12px;
      }
      :deep(.right-item):last-of-type {
        margin-bottom: 0px;
      }
    }
  }
  // .box-foot{
  //   // width:100%;
  //   margin: 0 auto;
  //   margin-top: 120px;
  // }
}
</style>
